// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PUndoOutlinedSvg from "@fishx/icons-svg/es/asn/PUndoOutlined";
import FishxIcon from '../components/FishxIcon';

var PUndoOutlined = function PUndoOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PUndoOutlinedSvg
  }));
};

PUndoOutlined.displayName = 'PUndoOutlined';
export default React.forwardRef(PUndoOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PUndoOutlined.js
// module id = 3695
// module chunks = 0